import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import categoriesData from "../../../../../jsonData/categoryData.json";
import AdmissionTest from "../../../../../jsonData/AdmissionTest.json";
import BanglaVersion from "../../../../../jsonData/BanglaVersion.json";
import EnglishVersion from "../../../../../jsonData/EnglishVersion.json";
import EnglishMedium from "../../../../../jsonData/EnglishMedium.json";
import MadrasaMedium from "../../../../../jsonData/MadrasaMedium.json";
import ReligiousStudies from "../../../../../jsonData/ReligiousStudies.json";
import Arts from "../../../../../jsonData/arts.json";
import TestPreparation from "../../../../../jsonData/TestPreparation.json";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import GreenSpinner from "../../../../Shared/Loading/GreenSpinner";

// Map categories to subjects
const categorySubjects = {
  BanglaVersion: BanglaVersion,
  EnglishVersion: EnglishVersion,
  EnglishMedium: EnglishMedium,
  MadrasaMedium: MadrasaMedium,
  ReligiousStudies: ReligiousStudies,
  AdmissionTest: AdmissionTest,
  TestPreparation: TestPreparation,
  Arts: Arts,
};

const dateFormat = (dateString) => {
  // Array of month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Create a new Date object
  const date = new Date(dateString);

  // Extract the month, day, and year
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  // Format the date as "Jul 31, 2024"
  return `${month} ${day}, ${year}`;
};

const AdminShortListedGreen = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [gender, setGender] = useState("any");
  const [city, setCity] = useState("");
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const [jobId, setJobId] = useState(""); // New state to hold the jobId input

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setCategories(categoriesData);
  }, []);

  const [appliedFilters, setAppliedFilters] = useState({
    gender: "any",
    city: "",
    areas: [],
    startDate: "",
    endDate: "",
    subjects: [],
    categories: [],
  });

  useEffect(() => {
    if (selectedCategories.length > 0) {
      const newSubjects = selectedCategories.flatMap(
        (category) => categorySubjects[category] || []
      );
      setSubjects(newSubjects);
    } else {
      setSubjects([]);
      setSelectedSubjects([]);
    }
  }, [selectedCategories]);

  const fetchJobs = useCallback(async () => {
    try {
      const response = await axios.get("https://tutor-tree-server-1.vercel.app/green-shortlisted-all", {
        params: {
          page,
          limit: 10,
          ...appliedFilters,
          areas: selectedAreas.join(","),
          categories: selectedCategories.join(","),
          subjects: selectedSubjects.join(","),
          jobId,
        },
      });
      setJobs(response.data.jobs);
      setTotalPages(response.data.pages);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [
    page,
    appliedFilters,
    jobId,
    selectedAreas,
    selectedCategories,
    selectedSubjects,
  ]);

  useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);

  const handlePreviousPage = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNextPage = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handleSearch = () => {
    setAppliedFilters({
      gender,
      city,
      areas: selectedAreas,
      startDate,
      endDate,
      categories: selectedCategories,
      subjects: selectedSubjects,
    });
    setPage(1); // Reset to the first page
  };

  const clearFilters = () => {
    setGender("any");
    setCity("");
    setSelectedAreas([]);
    setStartDate("");
    setEndDate("");
    setSelectedCategories([]);
    setSelectedSubjects([]);
    setAppliedFilters({
      gender: "any",
      city: "",
      areas: [],
      startDate: "",
      endDate: "",
      subjects: [],
      categories: [],
    });
    setPage(1); // Reset to the first page
  };

  const handleJobIdChange = (e) => {
    setJobId(e.target.value);
  };

  if (loading) {
    return <GreenSpinner></GreenSpinner>;
  }
  return (
    <div className="bg-white h-screen">
      <div className="w-full h-20 flex justify-start pl-5 items-center bg-green-500 shadow-md">
        <h2 className="text-xl text600 text-start text-white font-montserrat">
          Shortlisted
        </h2>
      </div>
      <div className="flex rounded-lg dropdown-container sticky top-0 z-40 shadow-md  justify-between items-center py-4 px-6 bg-green-50 w-full">
        <div className="flex flex-row items-center">
          <div className="grid grid-cols-2 gap-2">
            <div className="">
              <label className="block mb-2 text-lg font-montserrat text-green-900">
                Start Date
              </label>
              <input
                type="date"
                value={startDate}
                onChange={handleStartDateChange}
                className="w-full p-2 py-4 rounded-lg !border-2 border-green-300 text-lg font-montserrat text-green-900"
              />
            </div>

            <div className="mb-4">
              <label className="block mb-2 text-lg font-montserrat text-green-900">
                End Date
              </label>
              <input
                type="date"
                value={endDate}
                onChange={handleEndDateChange}
                className="w-full p-2 py-4 rounded-lg !border-2 border-green-300 text-lg font-montserrat text-green-900"
              />
            </div>
          </div>

          <div className="flex flex-row gap-5 ml-5 mt-4">
            <button
              onClick={handleSearch}
              className="text-white px-6 py-4 rounded bg-green-600 duration-300 font-roboto text-xl"
            >
              Search
            </button>
            <button
              onClick={clearFilters}
              className="text-green-900 ml-2 px-6 py-4 rounded bg-green-100 duration-300 font-roboto text-xl"
            >
              Clear
            </button>
          </div>
        </div>
        <div className="flex flex-row">
          <input
            className="border border-green-400 rounded font-montserrat focus:border-green-600"
            type="text"
            value={jobId}
            onChange={handleJobIdChange}
            placeholder="Enter Job ID"
          />
        </div>
      </div>

      <div className="w-full bg-white mt-5">
        <div class=" overflow-x-auto h-[600px]">
          <div class="relative  shadow-md sm:rounded-lg">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead class="text-xs text-white uppercase bg-green-500 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" class="px-6 py-3">
                    #
                  </th>

                  <th scope="col" class="px-6 py-3">
                    Job Id
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Name
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Joining Date
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Class Booked
                  </th>
                  <th scope="col" class="px-6 py-3">
                    <span class="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              {jobs.map((job, index) => (
                <tbody>
                  <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {index + 1}
                    </th>

                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {job.jobId}
                    </th>
                    <td class="px-6 py-4">
                      {job.name} {job.posterName}
                    </td>
                    <td class="px-6 py-4">{dateFormat(job.joiningDate)}</td>

                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {job.GreenClassBooked === "done" ? (
                        <img
                          className="w-8 h-8"
                          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTExLjM3NSA1MTEuMzc1IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyIiB4bWw6c3BhY2U9InByZXNlcnZlIiBjbGFzcz0iIj48Zz48cGF0aCBmaWxsPSIjMGVkNjc4IiBkPSJtNTExLjM3NSAyNTUuNjg4LTU3Ljg5LTY0LjI3MyA5LjA2NC04Ni4wNDYtODQuNjUxLTE3LjkyLTQzLjE4LTc1LjAxMi03OS4wMyAzNS4zMjEtMTAuNjY3IDIwNy45MyAxMC42NjcgMjA3LjkyOSA3OS4wMzEgMzUuMzIxIDQzLjE3OS03NS4wMTEgODQuNjUxLTE3LjkyMS05LjA2NC04Ni4wNDZ6IiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMGVkNjc4Ij48L3BhdGg+PHBhdGggZmlsbD0iIzA0ZWI4NCIgZD0ibTE3Ni42NTYgMTIuNDM3LTQzLjE3OSA3NS4wMTItODQuNjUxIDE3LjkyMSA5LjA2NCA4Ni4wNDVMMCAyNTUuNjg4bDU3Ljg5IDY0LjI3Mi05LjA2NCA4Ni4wNDYgODQuNjUxIDE3LjkyMSA0My4xOCA3NS4wMTEgNzkuMDMxLTM1LjMyMVY0Ny43NTh6IiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDRlYjg0Ij48L3BhdGg+PHBhdGggZmlsbD0iI2Y3ZjBlYiIgZD0ibTM2Mi44NzggMTk5LjcwMi0yMi4zODEtMTkuOTc3LTg0LjgwOSA5NS4wMTYtMTAuNjY3IDIzLjYxMyAxMC42NjcgMjEuNDM5eiIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iI2Y3ZjBlYiI+PC9wYXRoPjxwYXRoIGZpbGw9IiNmZmZiZjUiIGQ9Im0xNjYuNTYgMjMzLjA5NS0yMS4yMTIgMjEuMjEzIDg5LjE4NSA4OS4xODYgMjEuMTU1LTIzLjcwMXYtNDUuMDUybC0yMi4zOTMgMjUuMDg4eiIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iI2ZmZmJmNSI+PC9wYXRoPjwvZz48L3N2Zz4="
                        />
                      ) : (
                        <img
                          className="w-8 h-8"
                          src="data:image/svg+xml;base64,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"
                        />
                      )}
                    </th>

                    <td class="px-6 py-4 text-right">
                      <Link
                        to={`/dashboardTwo/AdminSortListedDetails/${job._id}`}
                      >
                        <button class="font-medium text-blue-600 dark:text-blue-500 hover:underline">
                          View
                        </button>
                      </Link>
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
            <div className="flex justify-center items-start ">
              <div className="flex justify-between my-5 w-[300px]">
                <button onClick={handlePreviousPage} disabled={page === 1}>
                  <img
                    className="w-10"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEsLTEuMjI0NjQ2Nzk5MTQ3MzUzMmUtMTYsMS4yMjQ2NDY3OTkxNDczNTMyZS0xNiwtMSw1MTIsNTEyKSI+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
                  />
                </button>
                <span className="text-lg font-roboto">
                  Page {page} of {totalPages}
                </span>
                <button onClick={handleNextPage} disabled={page === totalPages}>
                  <img
                    className="w-10"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminShortListedGreen;
